import { Group, GroupActionsList, GroupSampleData } from "../actions/groupActions";
import { Action } from "../actions/types";


export const groupReducer = (state: Group[] = GroupSampleData, action: Action) => {

    switch (action.type) {

        case GroupActionsList.ADD_GROUP: {

            return [...state, action.data]
        }

        case GroupActionsList.EDIT_GROUP: {

            const index = state.findIndex(i => i.id === action.id)
            const newState = [...state]

            if (index > -1) {
                newState[index] = {
                    ...action.data,
                    id: action.id
                }
            }
            return newState
        }

        case GroupActionsList.FETCH_GROUP: {

            return state
        }

        case GroupActionsList.DELETE_GROUP: {
            return state.filter(i => i.id !== action.data.id)

        }

        default: return state
    }

}